import { render, staticRenderFns } from "./commonElectiveStatisticList.vue?vue&type=template&id=6eba0b69&scoped=true"
import script from "./commonElectiveStatisticList.vue?vue&type=script&lang=js"
export * from "./commonElectiveStatisticList.vue?vue&type=script&lang=js"
import style0 from "./commonElectiveStatisticList.vue?vue&type=style&index=0&id=6eba0b69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba0b69",
  null
  
)

export default component.exports